module.exports = __webpack_public_path__ + "img/VPC-Main.b1c5b7f.24efcd3.svg";